module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_45deg.267ccfff.png";